import { render, staticRenderFns } from "./create-modal.vue?vue&type=template&id=215d08e6&scoped=true"
import script from "./create-modal.vue?vue&type=script&lang=js"
export * from "./create-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215d08e6",
  null
  
)

export default component.exports